import ShopifyOrders from './shopify-orders';

export default ShopifyOrders;
